import type { SVGProps } from "react";
export interface Hierarchy02IconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function Hierarchy02Icon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: Hierarchy02IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M16.375 16v-2.874h-8.75v2.873a1.125 1.125 0 0 1-2.25 0v-2.873H3a1.125 1.125 0 0 1 0-2.25h7.875V8a1.125 1.125 0 0 1 2.25 0v2.876H21l.116.005a1.125 1.125 0 0 1 0 2.239l-.116.006h-2.375v2.873a1.125 1.125 0 0 1-2.25 0Z"
      />
      <path
        fill={color}
        d="M15.124 19.875h4.751v-2.75h-4.75zm-10.999 0h4.75v-2.75h-4.75zm5-13h5.75v-2.75h-5.75zm2 13.125A2.126 2.126 0 0 1 9 22.125H4A2.126 2.126 0 0 1 1.875 20v-3c0-1.174.952-2.124 2.125-2.124h5c1.173 0 2.125.95 2.126 2.124zm11 0A2.126 2.126 0 0 1 20 22.125h-5A2.126 2.126 0 0 1 12.874 20v-3c0-1.174.953-2.124 2.126-2.124h5c1.173 0 2.125.95 2.125 2.124zm-5-13A2.125 2.125 0 0 1 15 9.125H9A2.125 2.125 0 0 1 6.875 7V4c0-1.173.951-2.125 2.125-2.125h6c1.174 0 2.125.952 2.125 2.125z"
      />
    </svg>
  );
}
